import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { adminApi, api, errMsg } from "@/lib/api";

export function MaintenanceToggle() {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get("/maintenance", { params: { _: Date.now() } }).then((r) => setOn(r.data.on)).catch(() => setOn(false)); }, []);
  const change = async (next) => {
    if (next && !window.confirm("Turn maintenance mode on? Visitors will see the maintenance page instead of the website.")) return;
    try {
      const { data } = await adminApi.put("/maintenance", { on: next });
      setOn(data.on);
      toast.success(data.on ? "Maintenance mode is on. The public website now shows the maintenance page." : "Maintenance mode is off. The website is back.");
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (on === null) return null;
  return (
    <label className={`flex h-10 items-center gap-2 rounded-xl border px-3 text-sm font-semibold ${on ? "border-rose-400/50 bg-rose-500/15 text-rose-200" : "border-white/10 text-slate-300"}`} data-testid="maintenance-toggle">
      <span>Maintenance</span>
      <span className="font-mono text-xs font-bold" data-testid="maintenance-state">{on ? "ON" : "OFF"}</span>
      <Switch checked={on} onCheckedChange={change} data-testid="maintenance-switch" aria-label="Maintenance mode" />
    </label>
  );
}
